import { Buffer } from 'buffer';
export default class AccessToken {
  constructor(accessToken) {
    this.accessToken = accessToken || '';
    this.payload = this.decodePayload();
  }
  getToken() {
    return this.accessToken;
  }
  getExpiration() {
    return this.payload.exp;
  }
  getIssuedAt() {
    return this.payload.iat;
  }
  getSubject() {
    return this.payload.sub;
  }
  decodePayload() {
    const payload = this.accessToken.split('.')[1];
    try {
      return JSON.parse(Buffer.from(payload, 'base64').toString('utf8'));
    } catch (err) {
      return {};
    }
  }
}